import React, { useMemo, useState } from 'react';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import { Checkbox, FormControlLabel } from '@mui/material';

export const StepRequisitosTipoPrograma = ({ fullFormData, handleChangeFullFormData, tipoModulo, clientsOptionsLoading, REQUISITOS, allowedWrite }) => {

    const [requisitosHook] = useState(REQUISITOS.filter(x => fullFormData[x.name] == 1 || fullFormData[x.name] == 2));
    const handleCheck = (e) => {
        const id = parseInt(e.target.name);
        const value = parseInt(e.target.value);

        const requisitoExistente = !!fullFormData.t_RequisitoTipoModulo?.find(
            requisito => requisito.idRequisito === id && requisito.idTipoModulo === value
        );

        if (requisitoExistente) {
            handleChangeFullFormData('t_RequisitoTipoModulo',
                (fullFormData.t_RequisitoTipoModulo || []).filter(requisito =>
                    !(requisito.idRequisito === id && requisito.idTipoModulo === value)
                )
            );
        } else {
            handleChangeFullFormData('t_RequisitoTipoModulo',
                [
                    ...(fullFormData.t_RequisitoTipoModulo || []),
                    {
                        idRequisito: id,
                        idTipoModulo: value
                    }
                ]
            );
        }
    };
    const initialColumns = [
        {
            flex: 0.5,
            field: 'fieldName',
            headerName: '',
            renderCell: ({ row }) => <p>{row.descripcion}</p>,
        },
        ...tipoModulo.map(modulo => ({
            flex: 0.2,
            field: modulo.abreviacion,
            align: 'center',
            headerAlign: 'start',
            headerName: modulo.abreviacion,
            renderCell: ({ row, index }) => (
                <FormControlLabel
                    key={'controlLabel-' + row.id + index + modulo.idTipoModulo}
                    control={
                        <Checkbox
                            checked={Boolean(fullFormData.t_RequisitoTipoModulo?.some(requisito => requisito.idRequisito === row.id && requisito.idTipoModulo === modulo.idTipoModulo))}
                            size="small"
                            id={index}
                            key={'check-' + row.id + index + modulo.idTipoModulo}
                            disabled={!allowedWrite}
                            name={row.id.toString()}
                            value={modulo.idTipoModulo}
                            onChange={handleCheck}
                        />
                    }
                />
            ),
        })),
    ];
    const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [tipoModulo, fullFormData.t_RequisitoTipoModulo]);

    return (
        <div>
            <DataGridGenerico
                columns={columns}
                rows={clientsOptionsLoading ? [] : requisitosHook}
                toolbar={false}
                loading={clientsOptionsLoading}
                pageSize={25}
            />
        </div>
    )
}